import axios from "axios";
import endPoints from "../../../../../config/endPoints";


export const getAllRegionsApi = async() => {
  return axios.get(`${endPoints.regions}`);
};

export const searchRegionsApi = async(string) => {
  return axios.post(`${endPoints.regions}/search`, string);
};

